<template>
  <div id="aside"
       class="flex ac">
    <img src="./img/side/logo.png"
         class="logo"/>
    <div class="aside_split"></div>
    <div class="side_menu scroll">
      <div :class="['item',$route.path.indexOf('square')>-1?'active':'link']"
           @click="handleJump('/square')">
        <div class="item_icon">
          <div class="left_line"></div>
          <img class="icon_img image_icon" src="@/views/objIcon/MJ.png" alt=" "/>
          <div class="right_line"></div>
        </div>
        <p class="item_name">绘画广场</p>
      </div>
      <div :class="['item',$route.path.indexOf('mj')>-1?'active':'link']"
           @click="handleJump('/mj')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/mj-gary.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/mj.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">MJ绘画</p>
      </div>

      <div :class="['item',$route.path.indexOf('sd')>-1?'active':'link']"
           @click="handleJump('/sd')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/sd-gary.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/sd.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">SD绘画</p>
      </div>

      <el-popover placement="right-start" width="950" trigger="hover"
                  :visible-arrow="true" popper-class="video_popup1">
        <div class="video_poppanel">
          <div class="panel_tabs">
            <div class="tab_item" @click="handleJump(item.go)" v-for="item in ListBeautify">
              <div class="img_box">
                <img class="tab_icon" :src="item.img" alt="" loading="lazy">
              </div>
              <span>{{item.name}}</span>
            </div>

          </div>
        </div>
        <div :class="['item',$route.path.indexOf('aiBeautify')>-1?'active':'link']"
             @click="handleJump('/aiBeautify')" slot="reference">
<!--          <div :class="['item',$route.path.indexOf('aiBeautify')>-1?'active':'link']" slot="reference">-->
          <div class="item_icon">
            <div class="left_line"></div>
            <div class="img_wrap">
              <img class="icon_img" src="./img/side/ai-gary.png" alt=" "/>
              <img class="icon_img icon_img-bright" src="./img/side/ai.png" alt=" "/>
            </div>
            <div class="right_line"></div>
          </div>
          <p class="item_name">AI变美</p>
        </div>
      </el-popover>


      <div class="item" :class="isWorkflowPath?'active':'link'"
           @click="handleJump('/workflow?arrange=5&relation=0')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/paint-gary.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/paint.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">换风格</p>
      </div>

      <el-popover placement="right-end" width="950" trigger="hover"
                  :visible-arrow="true" popper-class="video_popup1">
        <div class="video_poppanel">
          <div class="panel_tabs">
            <div class="tab_item" @click="handleJump(item.go)" v-for="item in ListToll">
              <div class="img_box">
                <img class="tab_icon" :src="item.img" alt="" loading="lazy">
              </div>
              <span>{{item.name}}</span>
            </div>

          </div>
        </div>
        <!--        <div :class="['item',$route.path.indexOf('aiBeautify')>-1?'active':'link']"-->
        <!--             @click="handleJump('/aiBeautify')" slot="reference">-->
        <div :class="['item',$route.path.indexOf('aiTool')>-1?'active':'link']"
             @click="handleJump('/aiTool')"  slot="reference">
          <div class="item_icon">
            <div class="left_line"></div>
            <div class="img_wrap">
              <img class="icon_img" src="./img/side/tools-gary.png" alt=" "/>
              <img class="icon_img icon_img-bright" src="./img/side/tools.png" alt=" "/>
            </div>
            <div class="right_line"></div>
          </div>
          <div class="item_name">
            <div class="red_box"></div>
            工具箱
          </div>
        </div>
      </el-popover>
    </div>
    <div class="side_menu footer_menu">
      <div class="item"
           @click="show_open">
        <img src="./img/side/icon_img3.png"
             alt=" "/>
        <p class="item_name">会员</p>
      </div>
      <div class="item"
           @click="handleJump('/favorites')">
        <img class="icon_img" src="./img/side/icon_img4.png"
             alt=" "/>
        <p class="item_name">画夹</p>
      </div>
      <div class="item" @click="course()">
        <img class="icon_img" src="./img/side/icon_img5.png"
             alt=" "/>
        <p class="item_name">教程</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {
      video_tabs: [
        {name: '文生视频', tag: '01', type: 1},
        {name: '图生视频', tag: '02', type: 2},
        {name: 'Pika专业版', tag: '03', type: 3},
      ],
      zhaShow: false,
      ListBeautify:[
        {name:'照片一键变美',img:require('./img/side/beautify1.webp'),go:'/workflow?arrange=1&relation=3',},
        {name:'人物动漫化',img:require('./img/side/beautify2.webp'),go:'/workflow?arrange=2&relation=3',},
        {name:'人脸滤镜',img:require('./img/side/beautify3.webp'),go:'/workflow?arrange=3&relation=3',},
        {name:'人脸模糊(打码)',img:require('./img/side/beautify4.webp'),go:'/workflow?arrange=4&relation=3',},
        {name:'发型编辑',img:require('./img/side/beautify5.webp'),go:'/workflow?arrange=5&relation=3',},
        {name:'表情编辑',img:require('./img/side/beautify6.webp'),go:'/workflow?arrange=6&relation=3',},
        {name:'年龄・性別变换',img:require('./img/side/beautify7.webp'),go:'/workflow?arrange=7&relation=3',},
        // {name:'人脸美颜',img:require('./img/side/beautify8.webp'),go:'/workflow?arrange=8&relation=3',},
        {name:'人脸美妆',img:require('./img/side/beautify9.webp'),go:'/workflow?arrange=9&relation=3',},
        {name:'唇色变换器',img:require('./img/side/beautify10.webp'),go:'/workflow?arrange=10&relation=3',},
        {name:'人脸修复增强',img:require('./img/side/beautify11.webp'),go:'/workflow?arrange=11&relation=3',},
      ],
      ListToll:[
        {name:'DALL-E3绘画',img:require('../views/img/aiTool/dall.webp'),go:'/dallE3',},
        // {name:'哪吒2',img:require('../views/img/nezha/yangli.webp'),go:'/nezha',},
        {name:'极速高清无损放大',img:require('../views/img/aiTool/magnify.webp'),go:'/workflow?arrange=1&relation=0',},
        {name:'图像擦除',img:require('../views/img/aiTool/remove.webp'),go:'/workflow?arrange=2&relation=0',},
        {name:'黑白图像上色',img:require('../views/img/aiTool/colour.webp'),go:'/workflow?arrange=3&relation=0',},
        {name:'图像清晰度增强',img:require('../views/img/aiTool/repair.webp'),go:'/workflow?arrange=4&relation=0',},
        {name:'图像风格转换',img:require('../views/img/aiTool/cartoon.webp'),go:'/workflow?arrange=5&relation=0',},
        {name:'背景移除',img:require('../views/img/aiTool/capture.webp'),go:'/workflow?arrange=1&relation=1',},
        {name:'AI虚拟试衣',img:require('../views/img/aiTool/fittingRoom.webp'),go:'/workflow?arrange=2&relation=1',},
        {name:'头像提取',img:require('../views/img/aiTool/expansion.webp'),go:'/workflow?arrange=1&relation=2',},

      ],
    }
  },
  computed: {
    isWorkflowPath() {
      // 检查路径是否包含 /workflow
      const hasPath = this.$route.path.includes('/workflow');

      // 检查查询参数是否匹配
      const hasQuery = (
          this.$route.query.arrange === '5' &&
          this.$route.query.relation === '0'
      );

      // 返回结果
      return hasPath && hasQuery;
    }
  },
  methods: {
    handleJump(url) {
      console.log(url)
      // this.checkKehuTip()
      // if (this.$route.path != url) this.$router.push(url)

      if (this.$route.fullPath !== url) {
        this.$router.push(url).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err; // 非重复导航错误继续抛出
          }
        });
      }
    },

    checkKehuTip() {
      if (!this.$store.state.isLogin) return
      if (!this.$store.state.userInfo.vip_type) return
      // if(localStorage.getItem('clientDownDate')){
      //     this.$store.commit('showKehuTip', false)
      //     return
      // }
      if (localStorage.getItem('kehuTip')) {
        this.checkTimestamp()
        return
      }
      this.$store.commit('showKehuTip', true)
    },
    checkTimestamp() {
      // if(localStorage.getItem('kehuTip')){
      let kehuInfo = localStorage.getItem('kehuTip')
      kehuInfo = JSON.parse(kehuInfo)
      let start_time = kehuInfo.time
      const STORAGE_KEY = 'kehuTip';
      const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
      const TWELVE_HOURS2 = 168 * 60 * 60 * 1000; // 7天的毫秒数
      const currentTime = Date.now();

      // 计算时间差
      const timeDiff = currentTime - parseInt(start_time, 10);
      let clientDownDate = localStorage.getItem('clientDownDate') || 0
      console.log('clientDownDate', clientDownDate)

      // 超过12小时执行操作
      if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
        this.$store.commit('showKehuTip', true)
        // localStorage.setItem(STORAGE_KEY, currentTime); // 更新存储时间
      } else if ((timeDiff >= TWELVE_HOURS2) && clientDownDate) {
        this.$store.commit('showKehuTip', true)
      }
      // }
    },
    show_open() {
      // this.$store.commit('setShowOpen', true)
      // this.$router.push("/member");
      if(!this.$store.state.isLogin){
        this.$store.commit('setShowLogin', true)
        return
      }
      this.$store.commit('setisPayPopShow', true)
    },
    goVideo(type) {
      if (type == 3) {
        this.handleJump('/pika')
      } else {
        this.$store.commit('setVideoType', type);
        this.handleJump('/video')
      }
    },
    course() {
      console.log(11)
      window.open('https://docs.qq.com/doc/DUm9GTXdYa1NnbkxN', '_blank');
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#aside {
  width: 70px;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  padding: 4px 0;
  font-size: 12px;

  .logo {
    width: 48px;
    height: 48px;
  }

  .aside_split {
    margin-top: 15px;
    margin-bottom: 15px;
    width: 32px;
    height: 2px;
    background-color: #35363c;
  }

  .side_menu {
    .item {
      cursor: pointer;

      &.active {
        position: relative;

        .item_icon {
          .left_line {
            background-color: #fff;
          }

          .img_wrap {
            .icon_img-bright {
              z-index: 11;
            }
          }

          .image_icon {
            width: 48px;
          }
        }

        .item_name {
          color: #fff;
          font-weight: bold;
        }
      }

      &.link {
        position: relative;

        .item_icon {
          &:hover .left_line {
            height: 18px;
            background-color: #fff;
            animation: checked-animation .5s linear;
          }
        }
      }

      .item_icon {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        &:hover {
          .img_wrap {
            .icon_img-bright {
              z-index: 11;
            }
          }
        }

        .left_line {
          height: 36px;
          width: 4px;
          border-radius: 0 4px 4px 0;
          animation: checkeding-animation .5s linear;
        }

        .img_wrap {
          position: relative;
          display: flex;

          .icon_img-bright {
            z-index: 9;
            position: absolute;
            left: 0;
            top: 0;

            &:hover {
              border-radius: 12px;
              animation: img-animation .5s linear;
            }
          }

        }

        .img_wrap_zha {
          width: 48px;
          height: 48px;
          // background: #5865f2;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #313338;

          &:hover {
            background: #5865f2;
            border-radius: 12px;
            animation: img-animation .5s linear;
          }

          .icon_img_oth {
            width: 36px;
            height: 36px;
            // background: #313338;
            // display: none;
          }

          .icon_img-bright_oth {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // display: none;
            // background: #5865f2;
          }

          // &:hover .icon_img_oth{
          //     display: none;
          // }
          // &:hover .icon_img-bright_oth{
          //     display: inline-block;
          // }
        }

        .img_wrap_zha_act {
          background: #5865f2;
        }
      }

      .icon_img {
        position: relative;
        z-index: 10;
        width: 48px;
        height: 48px;
        border-radius: 24px;
        border: none;
      }

      .item_name {
        position: relative;
        margin-bottom: 15px;
        color: #b4b9bf;
        text-align: center;

        .red_box {
          width: 5px;
          height: 5px;
          top: 3px;
          right: 5px;
          background-color: #ff1e10;
          border-radius: 9999px;
          position: absolute;
          box-sizing: border-box;
        }
      }

    }

    &.scroll {
      flex: 1 1 0%;
      overflow-y: auto;
      width: 100%;
    }
  }
}

@keyframes img-animation {
  0% {
    border-radius: 24px;
  }

  50% {
    border-radius: 18px;
  }
  100% {
    border-radius: 12px;
  }
}

@keyframes checked-animation {
  0% {
    height: 0;
  }
  50% {
    height: 9px;
  }
  100% {
    height: 18px;
  }
}

@keyframes checkeding-animation {
  0% {
    height: 18px;
  }
  50% {
    height: 27px;
  }
  100% {
    height: 36px;
  }
}



.video_poppanel {
  color: #fff;

  .panel_title {
    font-weight: 700;
    margin-bottom: 8px;
  }

  .panel_tabs {
    display: flex;
    flex-wrap: wrap;
    //width: 308px;
    gap: 24px;

    .tab_item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 160px;
      cursor: pointer;


      &:hover {
        border-color: rgb(88, 101, 242)
      }

      .img_box {
        overflow: hidden;
        border-radius: 4px;
        border: 2px solid #010101 !important;
        margin-bottom: 4px;

        .tab_icon {
          width: 100%;
          display: block;
          border: none;
          height: auto;
          object-fit: contain;
        }
      }

      span {
        font-weight: 100;
        font-size: 14px;
      }

    }
  }
}
</style>
<style lang="scss">
.video_popup1 {
  background-color: #3f3c3a !important;
  border: 2px solid #b2b7bd !important;
  //box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3) !important;
  margin-left: -10px;
  padding: 18px 24px 24px !important;
  border-radius: 10px !important;
}

.el-popper .popper__arrow::after {
  bottom: 10px !important;
  left: -2px !important;
  border-right-color: #b2b7bd !important;
  border-left-width: 0 !important;
}
</style>
